import Tooltip from '@material-ui/core/Tooltip';
import ReportTwoTone from '@material-ui/icons/ReportTwoTone';
import React from "react";
import { LogItemHaveErrorFC } from "./types";

const LogItemHaveError:LogItemHaveErrorFC = ({haveError}) => haveError ? (
    <Tooltip title={"Имеются ошибки"}>
      <ReportTwoTone color={"error"} />
    </Tooltip>): null;

export default LogItemHaveError;